import styled from "styled-components"

import { MEDIA_QUERIES } from "@constants"

export const ContentTextWithImgDIV = styled.div`
  display: flex;
  position: relative;
  flex-direction: column-reverse;
  margin: var(--spacing--M) 0;
  gap: var(--spacing--S);

  ${MEDIA_QUERIES.M} {
    flex-direction: row;
    align-items: flex-start;
  }

  .image-wrapper {
    flex: 0 0 var(--max-width--column--3);

    ${MEDIA_QUERIES.M} {
      flex: 0 0 calc(33.3333% - var(--spacing--S));
    }

    ${MEDIA_QUERIES.L} {
      flex: 0 0 var(--max-width--column--3);
    }
  }

  .gatsby-image-wrapper {
    border-radius: var(--border-radius--S);

    ${MEDIA_QUERIES.L} {
      width: 100%;
    }
  }
`

export const ContentTextWithImgContentDIV = styled.div`
  position: relative;

  h1, h2, h3, h4, h5, h6 {
    margin-top: 0!important; // TODO: remove the media query 430?
  }

  p:last-of-type {
    margin-bottom: var(--spacing--M);
  }

  ${MEDIA_QUERIES.M} {
    flex: 0 0 66.6666%;
  }

  ${MEDIA_QUERIES.L} {
    flex: 0 0 calc(var(--text-max-width) * 0.72);

    p:last-of-type {
      margin-bottom: 0;
    }
  }
`
